import AdminList from '../views/administrators/adminList';
import AdminLog from '../views/administrators/adminLog';

import Main from '../views/main';

const Administrators = {
  path: '/admin-list',
  component: Main,
  title: '系统管理员',
  icon: 'el-icon-s-custom',
  meta: { keepAlive: true },
  children: [
    {
      path: '/admin-list',
      component: AdminList,
      name: 'adminList',
      title: '管理员列表',
      meta: { title: '管理员列表' ,keepAlive: true }
    },
    {
      path: '/admin-log',
      component: AdminLog,
      name: 'adminLog',
      title: '管理员操作日志',
      meta: { title: '管理员操作日志' ,keepAlive: true }
    }
  ]
};
export default Administrators;
